import React from "react";
import { ModalBuilder, Modal } from "@redriver/cinnamon";
import { deleteCustomerContact } from "./actions";
import DeleteIcon from "assets/icons/rubbish-bin.svg";
import { Image } from "semantic-ui-react";

const DeleteCustomerContact = ({ contact, customerId, onDeleted }) => (
  <ModalBuilder
    submitAction={deleteCustomerContact}
    submitParams={{ customerId, contactId: contact.id }}
    onSubmitted={onDeleted}
    renderTrigger={(showModal) => (
      <Image
        src={DeleteIcon}
        title="Delete Contact"
        onClick={(e) => {
          showModal();

          e.stopPropagation();
          e.nativeEvent.stopImmediatePropagation();
        }}
      />
    )}
    renderModal={(modalProps) => (
      <Modal.Confirmation {...modalProps} header="Delete contact">
        Are you sure you wish to delete contact <b>{contact.displayName}</b>?
      </Modal.Confirmation>
    )}
  />
);

export default DeleteCustomerContact;
